<template>
  <div>
    <div>
      <div class="fz24">{{ contentDetail.title }}</div>
      <div class="mt20" v-html="contentDetail.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "content",
  props: {
    contentDetail: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.mt20 {
  /deep/ img {
    width: 100% !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/designPage/template/components/content.vue